<template>
  <div class="dialog-wrap" :class="{ 'has-other-tips': tips }">
    <transition name="fade-in" @after-leave="closeDialog">
      <div v-if="showContent" class="dialog-container">
        <p class="dialog-title">{{ myTitle }}</p>
        <div
          class="dialog-tips-content"
          :class="[textAlign, { 'mb-30': hideButton }]"
          v-html="decorateContent"
          @click="handleContentClick"
        ></div>
        <p v-if="tips" class="tips-tips">{{ tips }}</p>
        <div v-if="type == 'tips' && !hideButton" class="account-ops">
          <Button
            class="swtich-account btn long-btn"
            pointClass="j-sure-tip-btn"
            @click="sendConfirmEvt"
          >
            {{ myConfirm }}
          </Button>
        </div>
        <div v-else-if="!hideButton" class="account-ops">
          <Button
            class="cencel-account btn cancel-btn"
            pointClass="j-cancle-tip-btn"
            @click="sendCancelEvt"
          >
            {{ myCancel }}
          </Button>
          <Button
            class="swtich-account btn confirm-btn"
            pointClass="j-sure-tip-btn"
            @click="sendConfirmEvt"
          >
            {{ myConfirm }}
          </Button>
        </div>

        <Icon
          class="close-btn"
          name="close"
          @click="sendCloseEvt"
          v-if="!hideButton"
        />
      </div>
    </transition>
    <transition name="fade-in">
      <div v-if="showContent" @click="sendCloseEvt" class="dialog-shade"></div>
    </transition>
  </div>
</template>

<script>
import bridge from '@utiles/officialStore/bridge';
export const CLOSE_DIALOG_EVENT = 'close_dialog';
export const CANCEL_EVENT = 'onCancel';
export const CONFIRM_EVENT = 'onConfirm';
export const SHOW_TIPS = 'showTipsDialog';
export const RESET_CONFIG = 'resetConfig';
export default {
  props: [
    'content',
    'title',
    'cancel',
    'confirm',
    'languages',
    'type',
    'tips',
    'textAlign',
    'limitKey',
    'limitText',
    'disableClose',
    'hideButton'
  ],
  data() {
    return {
      showContent: false,
      operateType: ''
    };
  },
  computed: {
    myTitle() {
      let tips = '';
      try {
        tips = this.title || this.languages.tips.toUpperCase();
      } catch {
        tips = 'tips';
      }
      return tips;
    },
    myCancel() {
      let cancel = '';
      try {
        cancel = this.cancel || this.languages.cancel.toUpperCase();
      } catch {
        cancel = 'CANCEL';
      }
      return cancel;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    },
    decorateContent() {
      const content = this.content;
      if (content == null || content == '') return '';

      const text = typeof content === 'string' ? content : String(content);

      // URL正则表达式，匹配http、https、ftp等协议的URL
      const urlRegex = /(https?:\/\/[^\s<>"]+|ftp:\/\/[^\s<>"]+)/gi;

      return text.replace(urlRegex, url => {
        return `<a href="javascript:;" data-url="${url}">${url}</a>`;
      });
    }
  },
  mounted() {
    this.showContent = true;
  },
  methods: {
    closeDialog() {
      if (this.type === 'newPopupWindow' && this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
        return;
      }
      this.$emit(CANCEL_EVENT, this.operateType);
      if (this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
      }
    },
    hideContent() {
      this.showContent = false;
    },
    sendCloseEvt() {
      if (this.disableClose) return;
      this.hideContent();
      this.operateType = 'close';
    },
    sendCancelEvt() {
      this.hideContent();
      this.operateType = 'cancel';
    },
    sendConfirmEvt() {
      this.hideContent();
      this.operateType = 'confirm';
    },
    handleContentClick(event) {
      // 事件委托处理a标签点击
      if (event.target.tagName === 'A' && event.target.dataset.url) {
        event.preventDefault();
        const url = event?.target?.dataset?.url;
        if (!url) return;
        if (bridge.runInsdk()) {
          bridge.callSdkMethod('openWebView', {
            url,
            loginDir: 0,
            appendParams: 1
          });
        } else {
          window.open(url, '_blank');
        }
      }
    }
  },
  beforeDestroy() {
    this.showContent = false;
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';

.dialog-wrap {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 40;
  justify-content: center;
  align-items: center;
}

.dialog-container {
  position: relative;
  z-index: 10;
  width: 720px;
  background: $backgroundColor;
  box-sizing: border-box;
  padding: 0;
}
.dialog-title {
  @include g-popup-title();
  box-sizing: border-box;
  text-align: center;
  margin: 0;
  padding: 40px 76px 10px;
  height: auto;
  line-height: 1.3;
}

.dialog-tips-content {
  overflow-y: auto;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 40px;
  width: 100%;
  min-height: 80px;
  max-height: 400px;
  line-height: 1.5;
  word-break: break-word;
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  color: #333;
  white-space: pre-wrap;
  &.notice {
    padding: 0 45px;
  }
  &.mb-30 {
    margin-bottom: 30px;
  }
}

.dialog-shade {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.left {
  display: block;
  box-sizing: border-box;
  text-align: left;
}
.center {
  display: block;
  box-sizing: border-box;
  text-align: center;
}
.close-btn {
  position: absolute;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.account-ops {
  .cancel-btn {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 35px;
    color: $themeColor;
    border: 1px solid $themeColor;
    margin-right: 40px;
    cursor: pointer;
  }
  .confirm-btn {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 35px;
    color: #fff;
    background: $themeColor;
    cursor: pointer;
  }
  .long-btn {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 24px;
    height: 80px;
    border-radius: 10px;
    padding: 0 35px;
    color: #fff;
    background: $themeColor;
  }
}
</style>
